'use client';

import React, { useContext, useEffect, useMemo } from 'react';
import isEmpty from 'lodash/isEmpty';
import styles from './helpCenterMiniView.module.scss';
import { findTopicsByID, getTopicIconByID } from '@/utils/helpCenterUtils';
import ArticlesPanel from './common/articlesPanel';
import SectionsContainer from './common/sectionsContainer';
import '@chewy/kib-menus-styles/dist/styles/kib-breadcrumbs.css';
import OHCContext from '@/providers/OHCContext';
import SearchResultsContainer from './common/searchResultsContainer';
import PageBottomIcon from '@/components/icons/search-results-ducks.svg';
import ExploreMorePanel from './common/exploreMorePanel';
import PopularTopicsContainer from './common/popularTopicsContainer';
import KibDivider from '@chewy/kib-divider-react';
import '@chewy/kib-divider-styles/dist/kib-divider.css';
import CustomerWelcomePanel from './common/customerWelcomePanel';

interface HelpCenterMiniViewProps {
  id?: string;
}

const HelpCenterMiniView: React.FC<HelpCenterMiniViewProps> = ({ id }) => {
  const { isMobileApp,navData, searchQuery, selectedTopic, setSelectedTopic, selectedSection, setSelectedSection, selectedArticle, setSelectedArticle, exploreChewyLinksData, isResultsLoading, searchResults, categoryIdsMap, isNavError, setIsNavError } = useContext(OHCContext);
  const isHelpResults = useMemo(() => !isEmpty(searchQuery), [searchQuery]);
  const topicIcon = useMemo(() => getTopicIconByID(selectedTopic?.categoryId, categoryIdsMap), [selectedTopic, categoryIdsMap]);

  useEffect(() => {
    // Listen for hash changes
    const handleHashChange = () => {
      const topics = findTopicsByID(navData, id);

      setIsNavError(!!topics?.isError);
      setSelectedTopic(topics?.topic);
      setSelectedSection(topics?.section);
      setSelectedArticle(topics?.article);
    };

    window.addEventListener('hashchange', handleHashChange);
    handleHashChange();

    // Cleanup the event listener
    return () => {
      window.removeEventListener('hashchange', handleHashChange);
    };
  }, [navData, id, setSelectedTopic, setSelectedSection, setSelectedArticle, setIsNavError]);

  return (
    <div className={styles.root}>
      <div className={styles.mainContent}>

        {isHelpResults || isNavError ? (
          <div className={styles.searchResultsPanel}>
            <SearchResultsContainer />
            {(isEmpty(searchResults) || isNavError) && !isResultsLoading &&
            <div className={styles.popularTopicsContainer}>
                <PopularTopicsContainer isRX={false} />
              </div>
            }
            <div className={styles.rightSidebar}>
              <ExploreMorePanel title={'Explore Chewy'} linksData={exploreChewyLinksData} />
            </div>
            <div className={styles.bottomIconContainer}>
            <PageBottomIcon />
            </div>
          </div>
        ) : selectedArticle ? (
          <div>
          {!isMobileApp && <KibDivider className={styles.miniViewDivider}/>}
          <ArticlesPanel articles={selectedSection?.sections} selectedArticle={selectedArticle} isDesktopMode={false} /></div>
        ) : selectedSection ? (
          <div className={styles.sectionsContainer}>
          <SectionsContainer sectionsData={selectedTopic?.sections} jumpID={`/${id}`} showViewAll={false} />
            <div className={styles.bottomIconContainer}>
              {topicIcon?.page}
            </div>
          </div>
        ) : (
          <div className={styles.sectionsContainer}>
            <div>
              <CustomerWelcomePanel />
            </div>
            <SectionsContainer sectionsData={navData} jumpID={null} showViewAll={true} />
            <div className={styles.bottomIconContainer}>
            {topicIcon?.page}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default HelpCenterMiniView;
